<!--
 * @Author: your name
 * @Date: 2021-04-14 15:11:36
 * @LastEditTime: 2021-07-15 09:43:28
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \topboomadmin\src\views\auction\Index.vue
-->
<template>
  <div class="page">
    <PageTitle :title="title"
               :routes="routes"></PageTitle>
    <router-view></router-view>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import PageTitle from '@/components/PageTitle'
export default {
  name: 'Brand',
  components: {
    PageTitle
  },
  computed: {
    title () {
      let name = '拼团商品管理'
      if (this.$route.name === 'BargainDetail') {
        if (this.$route.query.id) {
          name = '拼团商品详情'
        } else {
          name = '添加拼团商品'
        }
      }
      return name
    },
    ...mapState({
      routes: 'route'
    })
  }
}
</script>